<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card
          title="Dostawa i płatność"
          class="title-inline delivery-card h6"
        >
          <b-card-text class="order-card">
            <b-form-group
              label="Wybierz sposób dostawy"
              label-class="h6 font-weight-bold"
            >
              <b-row>
                <b-col xl="6" lg="8" md="10">
                  <p class="mb-0">
                    <span>
                      <img
                        v-if="version.includes('e-aktu')"
                        :src="styles.checkbox_new"
                        alt="check"
                        class="pb-1"
                      />
                      <!--                      <img v-else :src="styles.add" alt="check" class="pb-1" />-->
                      <input v-else type="checkbox" disabled />
                    </span>
                    <span v-if="!currentOs" class="os-title h6 font-weight-bold"
                      >Pierwsza aktualizacja oraz kolejne wersje w trakcie
                      roku</span
                    >
                    <span v-else
                      >Dostawa online przy uruchomieniu programu
                      {{ program.toUpperCase() }}<sup>®</sup></span
                    >
                  </p>
                  <p v-if="!currentOs" class="custom-margin">
                    będą dostarczane online przy uruchamianiu programu
                    {{ program.toUpperCase() }}<sup>®</sup>
                    jako e-aktualizacja
                  </p>
                </b-col>
                <b-col>
                  <span class="mr-auto font-weight-bold"> 0,00 zł</span>
                </b-col>
              </b-row>
              <div v-if="!onlyEmailDelivery">
                <h6 class="ml-4">Usługi dodatkowe</h6>
                <b-row>
                  <b-col xl="6" lg="8" md="10">
                    <div class="mx-4">
                      <order-checkbox
                        v-on:addproduct="
                          selectVersion('cd', version.includes('cd'))
                        "
                        :isChecked="version.includes('cd')"
                        :styles="styles"
                        text="PIERWSZĄ aktualizację chcę otrzymać wyłącznie na płycie CD"
                      ></order-checkbox>
                    </div>
                    <p v-if="version.includes('cd')" class="ml-4 pl-3">
                      Pierwsza aktualizacja wysłana będzie na płycie, kolejne
                      dostępne jako e-aktualizacja.
                    </p>
                  </b-col>
                  <b-col>
                    <span class="mr-auto font-weight-bold"
                      >{{ price(deliveryPrice) }} zł netto</span
                    >
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="6" lg="8" md="10">
                    <div class="mx-4">
                      <order-checkbox
                        v-on:addproduct="
                          selectVersion('email', version.includes('email'))
                        "
                        :isChecked="version.includes('email')"
                        :styles="styles"
                        text="KOLEJNE aktualizacje w ciągu roku dodatkowo chcę otrzymywać przez e-mail"
                      ></order-checkbox>
                    </div>
                  </b-col>
                  <b-col>
                    <span v-if="AUTO3" class="mr-auto font-weight-bold"
                      >{{ price(AUTO3.NETTO) }} zł netto</span
                    >
                  </b-col>
                </b-row>
              </div>
            </b-form-group>
            <hr v-if="!hidePayment" class="mt-0" />
            <b-form-group
              v-if="!hidePayment"
              label="Wybierz sposób płatności"
              label-class="h6 font-weight-bold"
            >
              <b-row>
                <b-col lg="auto">
                  <div class="mx-4">
                    <order-checkbox
                      v-on:addproduct="selectPayment('transfer')"
                      :isChecked="payment === 'transfer'"
                      :styles="styles"
                      text="<strong>Przelew (przedpłata) - preferowana forma płatności</strong>"
                    ></order-checkbox>
                  </div>
                  <p class="ml-4 pl-3">
                    Po złożeniu zamówienia zostanie wygenerowana PRO FORMA. Po
                    otrzymaniu zapłaty e-mailem zostanie przesłany link do
                    pobrania faktury (faktura dostępna będzie też w Moje Konto w
                    dziale Historia zamówień).
                  </p>
                </b-col>
                <b-row
                  v-if="version.includes('cd') && payment === 'transfer'"
                  class="mb-3"
                >
                  <b-col lg="auto ml-3">
                    <div class="ml-5">
                      <order-checkbox
                        v-on:addproduct="selectDelivery('dhl')"
                        :isChecked="delivery === 'dhl'"
                        :styles="styles"
                        text="Kurier DHL"
                      ></order-checkbox>
                    </div>
                  </b-col>
                  <b-col lg="auto">
                    <div class="mx-4">
                      <order-checkbox
                        v-on:addproduct="selectDelivery('post')"
                        :isChecked="delivery === 'post'"
                        :styles="styles"
                        text="Poczta Polska"
                      ></order-checkbox>
                    </div>
                  </b-col>
                </b-row>
              </b-row>

              <b-row>
                <b-col lg="auto">
                  <div class="mx-4">
                    <order-checkbox
                      v-on:addproduct="selectPayment('payu')"
                      :isChecked="payment === 'payu'"
                      :styles="styles"
                      :text="payuInnerText"
                    ></order-checkbox>
                  </div>
                  <p class="ml-4 pl-3">
                    Zapłata zostanie pobrana przez bezpieczny system PayU (karta
                    lub przelewy online). E-mailem zostanie przesłany link do
                    pobrania faktury (faktura dostępna będzie też w Moje Konto w
                    dziale Historia zamówień).
                  </p>
                  <span class="payu-info-credit ml-4 pl-3">
                    Tutaj kupisz <strong>NA RATY PayU</strong>!
                    <a
                      href="https://www.ksiega-podatkowa.pl/akademia-skp/zamowienie-programu-raty-payu?ref=wybierz_sposob_platnosci_MK"
                      target="_blank"
                      >Więcej ></a
                    >
                  </span>
                </b-col>
                <b-row
                  v-if="version.includes('cd') && payment === 'payu'"
                  class="mb-3"
                >
                  <b-col lg="auto ml-3">
                    <div class="ml-5">
                      <order-checkbox
                        v-on:addproduct="selectDelivery('dhl')"
                        :isChecked="delivery === 'dhl'"
                        :styles="styles"
                        text="Kurier DHL"
                      ></order-checkbox>
                    </div>
                  </b-col>
                  <b-col lg="auto">
                    <div class="mx-4">
                      <order-checkbox
                        v-on:addproduct="selectDelivery('post')"
                        :isChecked="delivery === 'post'"
                        :styles="styles"
                        text="Poczta Polska"
                      ></order-checkbox>
                    </div>
                  </b-col>
                </b-row>
              </b-row>

              <b-row v-if="version.includes('cd')">
                <b-col lg="12">
                  <div class="mx-4">
                    <order-checkbox
                      v-on:addproduct="selectPayment('on_delivery')"
                      :isChecked="payment === 'on_delivery'"
                      :styles="styles"
                      text="Pobranie (płatność kurierowi/listonoszowi)"
                    ></order-checkbox>
                  </div>
                  <p class="ml-4 pl-3">
                    Pierwszą aktualizację otrzymasz jednorazowo na płycie CD
                    wraz z fakturą. Płatności za zamówienie dokonasz u kuriera
                    lub listonosza.
                  </p>
                </b-col>
                <b-row
                  v-if="version.includes('cd') && payment === 'on_delivery'"
                >
                  <b-col lg="auto" class="ml-3">
                    <div class="ml-5">
                      <order-checkbox
                        v-on:addproduct="selectDelivery('dhl')"
                        :isChecked="delivery === 'dhl'"
                        :styles="styles"
                        text="Kurier DHL"
                      ></order-checkbox>
                    </div>
                  </b-col>
                  <b-col lg="auto">
                    <div class="mx-4">
                      <order-checkbox
                        v-on:addproduct="selectDelivery('post')"
                        :isChecked="delivery === 'post'"
                        :styles="styles"
                        text="Poczta Polska"
                      ></order-checkbox>
                    </div>
                  </b-col>
                </b-row>
              </b-row>
              <b-row v-if="walletBalance > 0 && allProducts.length > 0">
                <b-col lg="auto">
                  <div class="ml-4 pt-2">
                    <order-checkbox
                      v-on:addproduct="setDiscount(!isDiscountSet)"
                      :isChecked="isDiscountSet"
                      :styles="styles"
                      text="Chcę wykorzystać środki z Mojego portfela"
                    ></order-checkbox>
                  </div>
                </b-col>
                <b-col lg="1" class="px-0">
                  <b-form-group>
                    <b-form-input
                      id="amountFromWallet"
                      v-model="amountFromWallet"
                      :state="validateAmountFromWallet"
                      aria-describedby="amount-feedback"
                      type="number"
                    ></b-form-input>
                    <b-form-invalid-feedback id="amountFromWallet-feedback">
                      Kwota nie może być wyższa niż dostępne środki.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <div class="pt-2">zł netto</div>
                </b-col>
              </b-row>
              <b-row v-if="amountFromWallet && isDiscountSet">
                <b-col>
                  <p class="small text-danger ml-4">
                    Złożenie zamówienia oznacza wykorzystanie wskazanych
                    środków, także gdy zamówienie zostanie anulowane.
                  </p>
                </b-col>
              </b-row>
            </b-form-group>

            <b-row v-if="paymentWarning">
              <b-col lg="12" class="font-italic info-text">
                <i class="fas fa-exclamation-circle"></i>
                Zamówiłeś {{ cloudName }}. Tylko płatność za pomocą PayU
                gwarantuje Ci natychmiastowy dostęp do usługi
                {{ cloudName }} online.</b-col
              >
            </b-row>
            <hr />

            <b-row v-if="!hidePayment" class="address-data mt-4">
              <b-col lg="6">
                <b-card title="Dane do faktury" class="mb-1 noborder-card">
                  <b-card-text>
                    <order-checkbox
                      v-on:addproduct="setInvoiceData(showInvoice)"
                      :isChecked="showInvoice"
                      :product="showInvoice === false"
                      :styles="styles"
                      text="Dane do faktury inne niż dane licencyjne"
                    ></order-checkbox>
                    <b-form
                      v-if="showInvoice"
                      @change="updateInvoiceData()"
                      class="mt-2"
                    >
                      <b-row>
                        <b-col lg="8">
                          <b-form-group
                            label-cols-lg="3"
                            label="NIP"
                            label-for="nip"
                          >
                            <b-form-input
                              id="nip"
                              v-model="invoice.nip"
                              :state="validateInvoiceNip"
                              aria-describedby="nip-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback id="nip-feedback">
                              Niepoprawny NIP
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <b-col lg="4">
                          <span
                            v-b-tooltip.hover.topright="
                              'Wpisz NIP i Pobierz z GUS'
                            "
                          >
                            <b-button
                              variant="primary"
                              class="btn-accept-color checkboxPointer"
                              block
                              @click="requestDataFromGus"
                              :disabled="
                                invoice.nip === '' || loading.gusRequest
                              "
                              >Pobierz z GUS</b-button
                            ></span
                          >
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="12">
                          <b-form-group
                            label-cols-lg="2"
                            label="Nazwa 1"
                            label-for="name1"
                          >
                            <b-form-input
                              id="name1"
                              v-model="invoice.name1"
                              :state="validateInvoiceName1"
                              aria-describedby="name1-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback id="name1-feedback">
                              Max. 54 znaki
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="12">
                          <b-form-group
                            label-cols-lg="2"
                            label="Nazwa 2"
                            label-for="name2"
                          >
                            <b-form-input
                              id="name2"
                              v-model="invoice.name2"
                              :state="validateInvoiceName2"
                              aria-describedby="name2-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback id="name2-feedback">
                              Max. 54 znaki
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="12">
                          <b-form-group
                            label-cols-lg="2"
                            label="Adres"
                            label-for="address"
                          >
                            <b-form-input
                              id="iaddress"
                              v-model="invoice.address"
                              :state="validateInvoiceAddress"
                              aria-describedby="iaddress-feedback"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback id="iaddress-feedback">
                              Max. 35 znaków
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="5">
                          <b-form-group
                            label-cols-lg="auto"
                            label="Kod pocztowy"
                            label-for="postalCode"
                          >
                            <b-form-input
                              id="ipostalCode"
                              v-model="invoice.postalCode"
                              v-mask="'##-###'"
                              :state="validateInvoicePostcode"
                              aria-describedby="ipostalCode-feedback"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback id="ipostalCode-feedback">
                              Max. 6 znaków
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <b-col lg="7">
                          <b-form-group
                            label-cols-lg="auto"
                            label="Miejscowość"
                            label-for="city"
                          >
                            <b-form-input
                              id="icity"
                              v-model="invoice.city"
                              :state="validateInvoiceCity"
                              aria-describedby="icity-feedback"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback id="icity-feedback">
                              Max. 20 znaki
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-form>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col lg="6">
                <b-card
                  v-if="version.includes('cd')"
                  title="Dane do wysyłki"
                  class="mb-1 noborder-card"
                >
                  <b-card-text>
                    <order-checkbox
                      v-on:addproduct="setCorrespondenceData(AKL)"
                      :isChecked="AKL"
                      :product="AKL === false"
                      :styles="styles"
                      text="Dane korespondencyjne inne niż jak dane
                        licencyjne"
                    ></order-checkbox>
                    <b-form
                      v-if="AKL"
                      @change="updateCorrespondenceData()"
                      class="mt-2"
                    >
                      <b-row>
                        <b-col lg="12">
                          <b-form-group
                            label-cols-lg="2"
                            label="Nazwa"
                            label-for="akn"
                          >
                            <b-form-input
                              id="akn"
                              v-model="correspondence.AKN"
                              :state="validateAKN"
                              aria-describedby="akn-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback id="akn-feedback">
                              Max. 35 znaków
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="12">
                          <b-form-group
                            label-cols-lg="2"
                            label="Adres"
                            label-for="aka"
                          >
                            <b-form-input
                              id="aka"
                              v-model="correspondence.AKA"
                              :state="validateAKA"
                              aria-describedby="aka-feedback"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback id="aka-feedback">
                              Max. 35 znaków
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="12">
                          <b-form-group
                            label-cols-lg="auto"
                            label="Kod i miejscowość"
                            label-for="AKM"
                          >
                            <b-form-input
                              id="akm"
                              v-model="correspondence.AKM"
                              :state="validateAKM"
                              aria-describedby="akm-feedback"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback id="akm-feedback">
                              Max. 27 znaków
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-form>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
            <b-row
              ><p v-if="errors.length"></p>
              <ul>
                <li v-for="error in errors" :key="error" class="text-danger">
                  {{ error }}
                </li>
              </ul></b-row
            >
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <p class="bot-link" @click="runChat">
        <strong>Potrzebujesz szybkiej pomocy?<br /></strong>
        Zapytaj Wirtualnego Asystenta SKP<sup>®</sup> >
      </p>
      <b-button
        variant="secondary"
        class="mx-3 ml-auto my-3 btn-color"
        @click="backStep"
        >Wstecz</b-button
      >
      <b-button
        variant="success"
        class="mx-3 my-3 btn-accept-color"
        @click="forwardStep"
        >Dalej</b-button
      >
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OrderCheckbox from './OrderCheckbox';
import helper from './config/helperData';
import moment from 'moment/moment';
import NumbersHelper from '../../../helper/numbersHelper';

export default {
  name: 'OrderDelivery',
  components: { OrderCheckbox },
  props: {
    isAccountant: { type: Boolean, default: false },
    skpAdd: { default: null },
    skpAccountantAdd: { type: Boolean, default: false },
    styles: {},
  },
  data() {
    return {
      AUTO3: {},
      invoice: {
        nip: '',
        name1: '',
        name2: '',
        address: '',
        postalCode: '',
        city: '',
      },
      correspondence: {
        AKN: '',
        AKA: '',
        AKM: '',
      },
      errors: [],
      year: process.env.MIX_AKTU_YEAR,
      loading: {
        gusRequest: false,
      },
      deliveryProducts: [],
      walletBalance: 0,
      amountFromWalletToUse: null,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      licence: 'auth/userLicence',
      storeVersion: 'order/version',
      storePayment: 'order/payment',
      storeDelivery: 'order/delivery',
      invoiceData: 'order/invoiceData',
      showInvoiceData: 'order/showInvoice',
      correspondenceData: 'order/correspondenceData',
      AKLData: 'order/AKL',
      cartCloud: 'order/cartCloud',
      cartProducts: 'order/getCartProducts',
      isInCart: 'order/isInCartProducts',
      client: 'auth/client',
      osPrice: 'order/osPrice',
      currentOs: 'auth/currentOs',
      changeLicenceData: 'order/changeLicence',
      changeLicence: 'order/changeLicence',
      selectedCloudPlan: 'order/cloudPlan',
      selectedCloudMonths: 'order/cloudMonths',
      cloudPlan: 'order/cloudPlan',
      discount: 'order/discountRecommendation',
      isDiscountSet: 'order/discountFromRecommendationSet',
      cloudCartTotal: 'order/cloudCartTotal',
      seasonalDiscount: 'order/seasonalDiscount',
      totalOrderNet: 'order/totalNet',
      orderSource: 'order/orderSource',
    }),
    discountUsed() {
      return this.discount;
    },
    version() {
      return this.storeVersion;
    },
    payment() {
      return this.storePayment;
    },
    delivery() {
      return this.storeDelivery;
    },
    deliveryPrice() {
      return 50;
    },
    showInvoice() {
      return this.showInvoiceData;
    },
    AKL() {
      return this.AKLData;
    },
    aktuEmailAlreadyChecked() {
      let year = this.year.substring(2);

      return this.client['AUTO_' + year] === 3;
    },
    paymentWarning() {
      return (
        this.cartCloud.length > 0 && (this.payment == 2 || this.payment == 3)
      );
    },
    validateInvoiceNip() {
      if (this.invoice.nip && this.invoice.nip.length === 0) {
        return null;
      } else {
        return (this.invoice.nip && this.invoice.nip.length < 10) ||
          (this.invoice.nip && this.invoice.nip.length > 15)
          ? false
          : null;
      }
    },
    validateInvoiceName1() {
      return this.invoice.name1 && this.invoice.name1.length > 54
        ? false
        : null;
    },
    validateInvoiceName2() {
      return this.invoice.name2 && this.invoice.name2.length > 54
        ? false
        : null;
    },
    validateInvoicePostcode() {
      return this.invoice.postalCode && this.invoice.postalCode.length > 6
        ? false
        : null;
    },
    validateInvoiceAddress() {
      return this.invoice.address && this.invoice.address.length > 35
        ? false
        : null;
    },
    validateInvoiceCity() {
      return this.invoice.city && this.invoice.city.length > 20 ? false : null;
    },
    validateAKN() {
      return this.correspondence.AKN && this.correspondence.AKN.length > 35
        ? false
        : null;
    },
    validateAKA() {
      return this.correspondence.AKA && this.correspondence.AKA.length > 35
        ? false
        : null;
    },
    validateAKM() {
      return this.correspondence.AKM && this.correspondence.AKM.length > 27
        ? false
        : null;
    },
    validateAmountFromWallet() {
      if (this.amountFromWalletToUse) {
        return this.amountFromWalletToUse > this.totalOrderNet ||
          this.amountFromWalletToUse > this.walletBalance ||
          this.amountFromWalletToUse <= 0
          ? false
          : null;
      }
      return null;
    },
    hidePayment() {
      return (
        ((this.seasonalDiscount === 604 || this.seasonalDiscount === 610) &&
          this.totalOrderNet === 0) ||
        ((this.cartCloud.length === 0 || this.cloudPlan === 0) &&
          this.cartProducts.length === 0 &&
          (this.osPrice == 0 || !this.osPrice) &&
          !(this.version.includes('cd') || this.version.includes('email')) &&
          !this.changeLicenceData)
      );
    },
    onlyEmailDelivery() {
      return this.currentOs || this.cartCloud.length > 0;
    },
    payuInnerText() {
      return '<span>PayU (przelew online / płatność kartą)</span>';
    },
    cloudName() {
      return this.isAccountant || this.skpAccountantAdd
        ? 'SKP24 Connect Biuro'
        : this.program === 'skp'
        ? 'SKP24 Connect Firma'
        : 'SAM<sup>®</sup> Twoja Firma w Chmurze';
    },
    allProducts() {
      let products = [];

      if (
        !this.currentOs &&
        !this.skpAdd &&
        !(
          localStorage.getItem('staffName') === 'formsoft' &&
          localStorage.getItem('staffId') === '0'
        )
      ) {
        let osName;
        if (this.program == 'sam') {
          osName = 'Bezpłatne przejście na SKP® z Opieką Serwisową ';
        } else {
          osName = 'Opieka Serwisowa ';
        }
        products.push({
          label: osName + this.year,
          net: this.osPrice,
          vat: 23,
          gross: this.osPriceGross,
          quantity: 1,
        });
      }

      if (this.cartCloud.length > 0) {
        this.cartCloud.forEach((item) => {
          products.push({
            label: item.label,
            quantity: item.quantity,
            net: item.net,
            vat: item.vat,
            gross: item.gross,
          });
        });
      }

      if (this.changeLicence) {
        products.push({
          label: 'Przeniesienie licencji',
          net: this.changeLicence.NETTO,
          vat: this.changeLicence.VAT,
          gross: this.changeLicence.BRUTTO,
        });
      }

      this.cartProducts.forEach((item) => {
        products.push({
          label: this.isTransferFromSamToSkp(item)
            ? this.addedSkpTitle
            : item.label
            ? item.label
            : item.OPIS,
          quantity: item.quantity,
          net: item.NETTO,
          vat: item.VAT,
          gross: item.BRUTTO,
        });
      });

      products.sort(function (a, b) {
        return (
          (a.label === 'Zryczałtowany koszt przesyłki Kurier / Poczta Polska') -
          (b.label === 'Zryczałtowany koszt przesyłki Kurier / Poczta Polska')
        );
      });

      this.$store.commit('order/setSummaryProducts', products);

      return products;
    },
    totalOrderNet() {
      let allProducts = this.allProducts.reduce(function (sum, item) {
        return (
          sum +
          (Number(item.quantity) ? item.net * Number(item.quantity) : item.net)
        );
      }, 0);
      return allProducts;
    },
    totalOrderGross() {
      let totalOrderGross = this.allProducts.reduce(function (sum, item) {
        return (
          sum +
          (Number(item.quantity)
            ? item.gross * Number(item.quantity)
            : item.gross)
        );
      }, 0);
      return totalOrderGross;
    },
    addedSkpTitle() {
      return this.skpAccountantAdd
        ? 'Przejście z programu SAM<sup>®</sup> na SKP<sup>®</sup> Biuro'
        : 'Przejście z programu SAM<sup>®</sup> na SKP<sup>®</sup> Firma';
    },
    cloudOrderTitle() {
      let productName = this.cartCloud[0].label.split(':')[0];

      productName += ': ' + this.monthsNames(this.selectedCloudMonths);

      return productName;
    },
    osPriceGross() {
      return this.osPrice + this.osPrice * 0.23;
    },
    amountFromWallet: {
      get() {
        return this.totalOrderNet >= this.walletBalance
          ? this.walletBalance
          : this.totalOrderNet;
      },
      set(value) {
        this.amountFromWalletToUse = value;
      },
    },
  },
  created() {
    if (this.orderSource === 'os') {
      this.forwardStep();
    } else {
      this.getWalletBalance();
      this.invoice = Object.assign({}, this.invoiceData);
      this.correspondence = Object.assign({}, this.correspondenceData);
      this.getProductsPrices();
      this.getDeliveryPrices();
    }
  },
  methods: {
    forwardStep() {
      this.errors = [];
      this.validateInvoiceForm();
      this.validateCorrespondenceForm();
      this.validateDelivery();
      this.validateCountProducts();

      if (this.errors.length === 0) {
        this.updateInvoiceData();
        this.updateCorrespondenceData();
        this.setDiscount(this.discount !== 0 && this.discount !== null);
        // this.$store.commit('order/setTotalNet', this.totalOrderNet);
        // this.$store.commit('order/setTotalGross', this.totalOrderGross);
        this.$store.commit('order/incrementStep');
      }
    },
    backStep() {
      this.updateInvoiceData();
      this.updateCorrespondenceData();
      this.$store.commit('order/decrementStep');
    },
    getProductsPrices() {
      axios
        .get('/api/productsPrices/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          this.AUTO3 = data.filter((item) => item.ID === 28)[0];
        })
        .catch((error) => {});
    },
    getDeliveryPrices() {
      axios.get('/api/deliveryPrices/' + this.program).then(({ data }) => {
        this.deliveryProducts = data;
      });
    },
    getWalletBalance() {
      axios
        .get('/api/getWalletBalance/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          if (data.balance > 0) {
            this.walletBalance = data.balance;
            this.$store.commit('order/setWalletBalance', data.balance);
            if (this.isDiscountSet) {
              this.$store.commit(
                'order/setDiscountRecommendation',
                this.amountFromWallet
              );
            }
          }
        });
    },
    updateInvoiceData() {
      this.$store.commit('order/setInvoiceData', this.invoice);
    },
    updateCorrespondenceData() {
      this.$store.commit('order/setCorrespondenceData', this.correspondence);
    },
    validateInvoiceForm() {
      if (
        this.showInvoice === true &&
        (this.invoice.nip === '' ||
          this.invoice.nip.length > 15 ||
          this.invoice.nip.length < 10 ||
          this.invoice.name1 === '' ||
          this.invoice.name1.length > 54 ||
          this.invoice.address === '' ||
          this.invoice.address.length > 35 ||
          this.invoice.postalCode === '' ||
          this.invoice.postalCode.length > 6 ||
          this.invoice.city === '' ||
          this.invoice.city.length > 20)
      ) {
        this.errors.push('Uzupełnij dane do faktury.');
      }
    },
    validateCorrespondenceForm() {
      if (
        this.AKL === true &&
        (this.correspondence.AKN === '' ||
          this.correspondence.AKN.length > 54 ||
          this.correspondence.AKA === '' ||
          this.correspondence.AKA.length > 35 ||
          this.correspondence.AKM === '' ||
          this.correspondence.AKM.length > 27)
      ) {
        this.errors.push('Uzupełnij dane korespondencyjne.');
      }
    },
    validateDelivery() {
      if (this.version.includes('cd') && this.delivery === null) {
        this.errors.push('Wybierz sposób dostawy.');
      }
    },
    validateCountProducts() {
      if (this.allProducts.length === 0) {
        this.errors.push('Wybierz przynajmniej jeden produkt.');
      }
    },
    price(value) {
      return ((value * 100) / 100).toFixed(2).replace('.', ',');
    },
    requestDataFromGus() {
      if (this.showInvoice === true && this.invoice.nip !== '') {
        this.loading.gusRequest = true;
        let nip = this.parseNip(this.invoice.nip);

        axios
          .post('/api/gus', { nip: nip })
          .then((response) => {
            this.invoice.name1 = this.titleCase(response.data.name);
            this.invoice.address =
              response.data.street + ' ' + response.data.propertyNumber;
            this.invoice.postalCode = response.data.zipCode;
            this.invoice.city = response.data.city;
            this.loading.gusRequest = false;
          })
          .catch((error) => {
            this.loading.gusRequest = false;
            this.errors.push(error.response.data);
          });
      }

      return false;
    },
    titleCase(str) {
      let splitStr = str.split(' ');
      for (let i = 0; i < splitStr.length; i++) {
        if (
          splitStr[i].indexOf('.') === -1 &&
          splitStr[i].length > 1 &&
          splitStr[i].indexOf('"') === -1
        ) {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() +
            splitStr[i].toLowerCase().substring(1);
        }
      }

      return splitStr.join(' ');
    },
    parseNip(value) {
      return value.replace(/[\ \-]/gi, '');
    },
    selectVersion(value, inSelected) {
      if (!inSelected) {
        this.$store.commit('order/addVersion', value);
        if (value === 'email') {
          this.$store.commit('order/addProduct', this.AUTO3);
        }
        if (value === 'cd') {
          this.selectDelivery('dhl');
        }
      } else {
        this.$store.commit('order/removeVersion', value);
        if (value === 'email') {
          this.$store.commit('order/removeProduct', this.AUTO3);
        }
        if (value === 'cd') {
          this.$store.commit('order/setDelivery', null);
        }
      }

      if (this.storeVersion.includes('cd')) {
        this.$store.commit('order/removeVersion', 'e-aktu');
      } else {
        if (!this.storeVersion.includes('e-aktu')) {
          this.$store.commit('order/addVersion', 'e-aktu');
        }
      }

      if (this.storeVersion.includes('e-aktu')) {
        this.$store.commit('order/setDelivery', null);
        let that = this;
        this.deliveryProducts.forEach(function (item) {
          that.$store.commit('order/removeProduct', item);
        });
      }
    },
    selectPayment(value) {
      this.$store.commit('order/setPayment', value);
      if (this.storeVersion.includes('cd')) {
        this.selectDelivery('dhl');
      } else {
        this.$store.commit('order/setDelivery', null);
      }
    },
    selectDelivery(value) {
      this.$store.commit('order/setDelivery', value);
      let that = this;
      let product = this.deliveryProducts.filter((item) => item.key == value);

      this.deliveryProducts.forEach(function (item) {
        if (that.isInCart(item) && item.key !== value) {
          that.$store.commit('order/removeProduct', item);
        }
      });

      if (product.length > 0 && !this.isInCart(product[0])) {
        this.$store.commit('order/addProduct', product[0]);
      }
    },
    setInvoiceData(value) {
      this.$store.commit('order/setShowInvoice', !value);
      if (value) {
        this.invoice = {
          nip: '',
          name1: '',
          name2: '',
          address: '',
          postalCode: '',
          city: '',
        };
        this.$store.commit('order/setInvoiceData', this.invoice);
      }
    },
    setCorrespondenceData(value) {
      this.$store.commit('order/setAKL', !value);
      if (value) {
        if (!this.correspondence) {
          this.correspondence = {
            AKN: '',
            AKA: '',
            AKM: '',
          };
        }
        this.$store.commit('order/setCorrespondenceData', this.correspondence);
      }
    },
    setDiscount(value) {
      this.$store.commit('order/setDiscountFromRecommendation', value);

      if (value) {
        let amount = this.amountFromWalletToUse
          ? Number(this.amountFromWalletToUse)
          : this.amountFromWallet;
        this.$store.commit('order/setDiscountRecommendation', amount);

        this.$store.commit('order/setTotalNet', this.totalOrderNet - amount);
        this.$store.commit(
          'order/setTotalGross',
          this.totalOrderGross - (amount + amount * 0.23)
        );
      } else {
        this.$store.commit('order/setDiscountRecommendation', null);
        this.$store.commit('order/setTotalGross', this.totalOrderGross);
        this.$store.commit('order/setTotalNet', this.totalOrderNet);
      }
    },
    monthsNames(array) {
      let string = '';

      array.forEach((item) => {
        string += helper.months[item] + ', ';
      });

      return string.slice(0, -2);
    },
    commaFormat(value) {
      return Number(value).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    isTransferFromSamToSkp(item) {
      return (
        (item.UWAGI === 'N_SKP' && item.key !== 'O') ||
        (this.program === 'sam' &&
          (item.key === 'B1' || item.key === 'B2' || item.key === 'B3'))
      );
    },
    runChat() {
      document.getElementById('chatbase-bubble-button').click();
    },
  },
  watch: {
    version: function (value) {
      if (value.includes('cd')) {
        this.correspondence.AKN = this.client.AKN;
        this.correspondence.AKA = this.client.AKA;
        this.correspondence.AKM = this.client.AKM;
      }
    },
  },
};
</script>

<style scoped>
.custom-margin {
  margin-left: 18px;
}

.radios {
  margin: 0.2rem;
}
</style>
